import { NavigationMenuItemAlignmentEnum } from "@/scripts/common/enums.js";

export default {
    data() {
        return {
            navItemsWrapped: false,
            navWrapResizeObserver: null,
            navWrapAnimationFrame: null,
        };
    },
    mounted() {
        this.setupNavWrapObserver();
    },
    updated() {
        this.scheduleNavWrapCheck();
    },
    beforeUnmount() {
        this.teardownNavWrapObserver();
    },
    methods: {
        setupNavWrapObserver() {
            this.teardownNavWrapObserver();
            this.$nextTick(() => {
                const container = this.$refs.navbarContainer;
                if (!container || typeof ResizeObserver === "undefined") {
                    this.scheduleNavWrapCheck();
                    return;
                }

                this.navWrapResizeObserver = new ResizeObserver(() => {
                    this.scheduleNavWrapCheck();
                });
                this.navWrapResizeObserver.observe(container);
                this.scheduleNavWrapCheck();
            });
        },
        teardownNavWrapObserver() {
            if (this.navWrapResizeObserver) {
                this.navWrapResizeObserver.disconnect();
                this.navWrapResizeObserver = null;
            }
            if (this.navWrapAnimationFrame) {
                cancelAnimationFrame(this.navWrapAnimationFrame);
                this.navWrapAnimationFrame = null;
            }
        },
        scheduleNavWrapCheck() {
            if (this.navWrapAnimationFrame) return;
            const schedule = typeof requestAnimationFrame === "function"
                ? requestAnimationFrame
                : (callback) => setTimeout(callback, 0);

            this.navWrapAnimationFrame = schedule(() => {
                this.navWrapAnimationFrame = null;
                this.updateNavItemsWrapped();
            });
        },
        updateNavItemsWrapped() {
            const container = this.$refs.navbarContainer;
            if (
                !container
                || !this.isSidebarHeroNavigation
                || this.navigation?.layout?.menuItemAlignment !== NavigationMenuItemAlignmentEnum.HORIZONTAL
            ) {
                this.navItemsWrapped = false;
                return;
            }

            const firstItem = Array.from(container.children)
                .find((element) => element.offsetParent !== null);
            if (!firstItem) {
                this.navItemsWrapped = false;
                return;
            }

            this.navItemsWrapped = Array.from(container.children)
                .some((element) => element.offsetParent !== null && element.offsetTop > firstItem.offsetTop);
        },
    },
};
